export default "__VITE_ASSET__Ch75WjlQ__"